var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMusic(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0391 18.1503V7.84104C10.039 7.44006 10.1825 7.0523 10.4436 6.74796C10.7047 6.44362 11.0661 6.24281 11.4624 6.18186L19.0156 5.0195C19.2548 4.98272 19.4991 4.99809 19.7318 5.06458C19.9645 5.13106 20.1801 5.24707 20.3638 5.40467C20.5474 5.56227 20.6948 5.75772 20.7959 5.97762C20.897 6.19752 20.9493 6.43668 20.9492 6.67869V16.4718",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0391 10.6004L20.9492 8.92188",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0355 18.1538C10.0355 18.8216 9.7702 19.462 9.29804 19.9342C8.82587 20.4063 8.18547 20.6716 7.51773 20.6716C6.84999 20.6716 6.20959 20.4063 5.73743 19.9342C5.26526 19.462 5 18.8216 5 18.1538C5 16.7632 6.1271 16.4754 7.51773 16.4754C8.90836 16.4754 10.0355 16.7632 10.0355 18.1538ZM20.9456 16.4754C20.9456 17.1431 20.6804 17.7835 20.2082 18.2557C19.736 18.7278 19.0956 18.9931 18.4279 18.9931C17.7602 18.9931 17.1198 18.7278 16.6476 18.2557C16.1754 17.7835 15.9102 17.1431 15.9102 16.4754C15.9102 15.0847 17.0373 14.7969 18.4279 14.7969C19.8185 14.7969 20.9456 15.0847 20.9456 16.4754Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/icon-music.8eb89209.svg";
export { ForwardRef as ReactComponent };